/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Leaderboard_Page_TitleInputs */

const fr_leaderboard_page_title = /** @type {(inputs: Leaderboard_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Classement des Records Personnels`)
};

/**

* @param {Leaderboard_Page_TitleInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const leaderboard_page_title = /** @type {((inputs?: Leaderboard_Page_TitleInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Leaderboard_Page_TitleInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_leaderboard_page_title(inputs)
});